import { createAction, handleActions } from 'redux-actions';
import { _getShampooList, _deleteShampoo, _addShampoo, _editShampoo, _bulkUpdateShampoo } from '~shared/httpService/apis';
import ActionTypes from '~shared/constants/actionTypes';
import { _getShampooListByPagination } from '../../../shared/httpService/apis';

const initialState = {
  display_shampoo: null,
  shampoo_list: {
    loading: false,
    response: [],
    hasError: false,
    error: {}
  },
  add_shampoo: {
    loading: false,
    response: {},
    hasError: false,
    error: {}
  },
  edit_shampoo: {
    loading: false,
    response: {},
    hasError: false,
    error: {}
  },
  update_shampoo: {
    loading: false,
    response: {},
    hasError: false,
    error: {}
  },
  delete_shampoo: {
    loading: false,
    response: {},
    hasError: false,
    error: {}
  },
  shampoolist_paginated: {
    loading: false,
    response: [],
    hasError: false,
    error: {}
  },
};
//SHAMPOO LIST
export const getShampooListStart = createAction(ActionTypes.GET_SHAMPOO_LIST);
export const getShampooListSuccess = createAction(ActionTypes.GET_SHAMPOO_LIST_SUCCESS, response => response);
export const getShampooListError = createAction(ActionTypes.GET_SHAMPOO_LIST_ERROR, error => error);

export const getShampooList = (page = '', pageSize, searchQuery) => (dispatch) => {
  dispatch(getShampooListStart());
  return _getShampooList(page, pageSize, searchQuery).then((response) => {
    dispatch(getShampooListSuccess(response));
  }).catch((error) => {
    dispatch(getShampooListError(error));
  });
};

//ADD SHAMPOO
export const addShampooStart = createAction(ActionTypes.ADD_SHAMPOO);
export const addShampooSuccess = createAction(ActionTypes.ADD_SHAMPOO_SUCCESS, response => response);
export const addShampooError = createAction(ActionTypes.ADD_SHAMPOO_ERROR, error => error);

export const addShampoo = (data) => (dispatch) => {
  dispatch(addShampooStart());
  return _addShampoo(data).then((response) => {
    dispatch(addShampooSuccess(response));
  }).catch((error) => {
    dispatch(addShampooError(error));
  });
};

//EDIT SHAMPOO
export const editShampooStart = createAction(ActionTypes.EDIT_SHAMPOO);
export const editShampooSuccess = createAction(ActionTypes.EDIT_SHAMPOO_SUCCESS, response => response);
export const editShampooError = createAction(ActionTypes.EDIT_SHAMPOO_ERROR, error => error);

export const editShampoo = (id, data) => (dispatch) => {
  dispatch(editShampooStart());
  return _editShampoo(id, data).then((response) => {
    dispatch(editShampooSuccess(response));
  }).catch((error) => {
    dispatch(editShampooError(error));
  });
};

//BULK UPDATE SHAMPOO
export const bulkUpdateShampooStart = createAction(ActionTypes.BULK_UPDATE_SHAMPOO);
export const bulkUpdateShampooSuccess = createAction(ActionTypes.BULK_UPDATE_SHAMPOO_SUCCESS, response => response);
export const bulkUpdateShampooError = createAction(ActionTypes.BULK_UPDATE_SHAMPOO_ERROR, error => error);

export const bulkUpdateShampoo = (data) => (dispatch) => {
  dispatch(bulkUpdateShampooStart());
  return _bulkUpdateShampoo(data).then((response) => {
    dispatch(bulkUpdateShampooSuccess(response));
  }).catch((error) => {
    dispatch(bulkUpdateShampooError(error));
  });
};

//SHAMPOO DELETE
export const deleteShampooStart = createAction(ActionTypes.DELETE_SHAMPOO);
export const deleteShampooSuccess = createAction(ActionTypes.DELETE_SHAMPOO_SUCCESS, response => response);
export const deleteShampooError = createAction(ActionTypes.DELETE_SHAMPOO_ERROR, error => error);

export const deleteShampoo = (id) => (dispatch) => {
  dispatch(deleteShampooStart());
  return _deleteShampoo(id).then((response) => {
    dispatch(deleteShampooSuccess(response));
  }).catch((error) => {
    dispatch(deleteShampooError(error));
  });
};


//SHAMPOO LIST BY PAGINATION
export const ShampooPaginatedListStart = createAction(ActionTypes.GET_SHAMPOO_LIST_PAGINATED);
export const ShampooPaginatedListSuccess = createAction(ActionTypes.GET_SHAMPOO_LIST_PAGINATED_SUCCESS, response => response);
export const ShampooPaginatedListError = createAction(ActionTypes.GET_SHAMPOO_LIST_PAGINATED_ERROR, error => error);

export const getShampooListByPagination = (pageNo, pageSize, inputName) => (dispatch) => {
  dispatch(ShampooPaginatedListStart());
  return _getShampooListByPagination(pageNo, pageSize, inputName).then((response) => {
    dispatch(ShampooPaginatedListSuccess(response));
  }).catch((error) => {
    dispatch(ShampooPaginatedListError(error));
  });
};

const reducer = handleActions({

  // SHAMPOO LIST BY PAGINATION
  [ActionTypes.GET_SHAMPOO_LIST_PAGINATED]: (state) => ({
    ...state, shampoolist_paginated: {  
      ...state.shampoolist_paginated,
      loading: true, hasError: false, error: {}
    },
    display_shampoo: false
  }),
  [ActionTypes.GET_SHAMPOO_LIST_PAGINATED_SUCCESS]: (state, action) => (
    {
      ...state,
      shampoolist_paginated: {
        ...state.shampoolist_paginated,
        response: action.payload, loading: false, hasError: false, error: {}
      },
      display_shampoo: action.payload?.data?.active
    }),
  [ActionTypes.GET_SHAMPOO_LIST_PAGINATED_ERROR]: (state, action) => ({
    ...state,
    shampoolist_paginated: {
      ...state.shampoolist_paginated,
      error: action.payload, loading: false, hasError: true, response: {}
    },
    display_shampoo: null
  }),




  //SHAMPOO_LIST
  [ActionTypes.GET_SHAMPOO_LIST]: (state) => ({
    ...state, shampoo_list: {
      ...state.shampoo_list,
      loading: true, hasError: false, error: {}
    },
    display_shampoo: false
  }),
  [ActionTypes.GET_SHAMPOO_LIST_SUCCESS]: (state, action) => (
    {
      ...state,
      shampoo_list: {
        ...state.shampoo_list,
        response: action.payload, loading: false, hasError: false, error: {}
      },
      display_shampoo: action.payload?.data?.active
    }),
  [ActionTypes.GET_SHAMPOO_LIST_ERROR]: (state, action) => ({
    ...state,
    shampoo_list: {
      ...state.shampoo_list,
      error: action.payload, loading: false, hasError: true, response: {}
    },
    display_shampoo: null
  }),
  //ADD_SHAMPOO
  [ActionTypes.ADD_SHAMPOO]: (state) => ({
    ...state,
    add_shampoo: {
      ...state.add_shampoo,
      loading: true, hasError: false, error: {}, response: {}
    }
  }),
  [ActionTypes.ADD_SHAMPOO_SUCCESS]: (state, action) => ({
    ...state,
    add_shampoo: {
      ...state.add_shampoo,
      response: action.payload, loading: false, hasError: false, error: {}
    }
  }),
  [ActionTypes.ADD_SHAMPOO_ERROR]: (state, action) => ({
    ...state,
    add_shampoo: {
      ...state.add_shampoo,
      error: action.payload, loading: false, hasError: true, response: {}
    }
  }),
  //EDIT_SHAMPOO
  [ActionTypes.EDIT_SHAMPOO]: (state) => ({
    ...state,
    edit_shampoo: {
      ...state.edit_shampoo,
      loading: true, hasError: false, error: {}, response: {}
    }
  }),
  [ActionTypes.EDIT_SHAMPOO_SUCCESS]: (state, action) => ({
    ...state,
    edit_shampoo: {
      ...state.edit_shampoo,
      response: action.payload, loading: false, hasError: false, error: {}
    }
  }),
  [ActionTypes.EDIT_SHAMPOO_ERROR]: (state, action) => ({
    ...state,
    edit_shampoo: {
      ...state.edit_shampoo,
      error: action.payload, loading: false, hasError: true, response: {}
    }
  }),
  //BULK EDIT
  [ActionTypes.BULK_UPDATE_SHAMPOO]: (state) => ({
    ...state,
    update_shampoo: {
      ...state.update_shampoo,
      loading: true, hasError: false, error: {}, response: {}
    }
  }),
  [ActionTypes.BULK_UPDATE_SHAMPOO_SUCCESS]: (state, action) => ({
    ...state,
    update_shampoo: {
      ...state.update_shampoo,
      response: action.payload, loading: false, hasError: false, error: {}
    },
    display_shampoo: action.payload?.data?.active
  }),
  [ActionTypes.BULK_UPDATE_SHAMPOO_ERROR]: (state, action) => ({
    ...state,
    update_shampoo: {
      ...state.update_shampoo,
      error: action.payload, loading: false, hasError: true, response: {}
    }
  }),
  //SHAMPOO DELETE
  [ActionTypes.DELETE_SHAMPOO]: (state) => ({
    ...state,
    delete_shampoo: {
      ...state.delete_shampoo,
      loading: true, hasError: false, error: {}, response: {}
    }
  }),
  [ActionTypes.DELETE_SHAMPOO_SUCCESS]: (state, action) => ({
    ...state,
    delete_shampoo: {
      ...state.delete_shampoo,
      response: action.payload, loading: false, hasError: false, error: {}
    }
  }),
  [ActionTypes.DELETE_SHAMPOO_ERROR]: (state, action) => ({
    ...state,
    delete_shampoo: {
      ...state.delete_shampoo,
      error: action.payload, loading: false, hasError: true, response: {}
    }
  }),
}, initialState);

export default reducer;
